import { isSubmitting } from 'redux-form';

import {
  getRoles,
  isUserCountAndQuotaLoading,
} from 'selectors/currentOrganization';

export const getFormOptions = state => state.addUsers.formOptions;

export const getRoleOptions = state =>
  state?.loggedInUser?.isCompanyAdmin
    ? getFormOptions(state)?.roleOptions
    : getFormOptions(state)?.roleOptionsByRoleOnRolePermissions;

export const getSiteOptions = state => getFormOptions(state)?.siteOptions;

export const getCustomProperties = state => state.addUsers.customProperties;

export const getRequiredBooleanProperties = state =>
  state.addUsers.requiredBooleanProperties;

export const isServiceProvidersLoading = state =>
  state?.addUsers?.serviceProvidersLoading;

export const isCreateUserModalLoading = (state, formName) =>
  isServiceProvidersLoading(state) ||
  !state?.addUsers?.formOptions ||
  getRoles(state)?.loading ||
  state?.addUsers?.siteOptionsLoading ||
  getCustomProperties(state)?.loading ||
  isUserCountAndQuotaLoading(state) ||
  isSubmitting(formName)(state);

export const getAddUsersInProgress = state =>
  state.addUsers.addedUsersInProgress;

export const isCreateUserModalOpen = state => state.addUsers.isOpen;
